module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg5.f4eb4f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg5.jpg
// module id = +RaQ
// module chunks = 6